import { useMemo } from 'react'
import { Text } from '../../../../../../components/Text'
import { formatCurrency } from '../../../../../../utils/currency'
import { AccountBannerRoot } from './AccountBannerRoot'

const toastVariantToIconMap: any = {
  success: 'check-fill',
  error: 'close-line',
  info: 'information-line',
}

type PromotionalCreditsBannerProps = {
  promotionalCredits: number | undefined
  totalSubscriptions: number | undefined
  clickHandler?: () => void
}

export const PromotionalCreditsBanner = (props: PromotionalCreditsBannerProps) => {
  const { promotionalCredits, totalSubscriptions } = props
  if (!promotionalCredits) return null
  return (
    <AccountBannerRoot bannerTone="info">
      <Text weight="semiBold" color="accent-white">
        You have redeemed {formatCurrency(promotionalCredits)} in promotional credits for your next
        order.{' '}
        {totalSubscriptions !== undefined &&
          totalSubscriptions > 1 &&
          `Depending on which subscription is next to bill, you will see the discount applied to
        that subscription.`}
      </Text>
    </AccountBannerRoot>
  )
}

PromotionalCreditsBanner.displayName = 'PromotionalCreditsBanner'
